import { WarrantyComponent } from './warranty.component';
import { runClientComponent } from '../../_common/client/client-component-runner';

runClientComponent({ WarrantyComponent });
